<template>
  <custom-scroll>
    <div class="object-card-content">
      <fetch-group-docs
        :project-schema="projectSchema"
        :section-id="group.gisogdSection"
        :group-key="group.key"
      >
        <template slot-scope="{ documents }">
          <group-doc
            v-for="doc in documents"
            :key="doc.key"
            :doc="doc"
            @activate="activateDoc"
          ></group-doc>
        </template>
      </fetch-group-docs>
      <transition name="fade">
        <div class="active-object-panel position-absolute" v-if="activeDoc">
          <a @click="goBack" class="go-back">
            <img src="../../../assets/svg/left_arrow.svg" />
          </a>
          <GisogdDocProperties
            :projectSchema="projectSchema"
            :doc="activeDoc"
            class="gisogd-doc-properties"
          ></GisogdDocProperties>
        </div>
      </transition>
    </div>
  </custom-scroll>
</template>
<script>
import FetchGroupDocs from "../../documents/FetchGroupDocs";
import GroupDoc from "./GroupDoc";
import GisogdDocProperties from "@/components/map/GisogdDocProperties";
export default {
  props: {
    projectSchema: {
      required: true,
      type: String,
    },
    group: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      activeDoc: null,
    };
  },
  components: {
    FetchGroupDocs,
    GroupDoc,
    GisogdDocProperties,
  },
  methods: {
    activateDoc(doc) {
      this.activeDoc = Object.assign(
        { gisogdSection: this.group.gisogdSection },
        doc
      );
    },
    goBack() {
      this.activeDoc = null;
    },
  },
  watch: {
    group: {
      handler: "goBack",
    },
  },
};
</script>
<style>
.position-absolute {
  position: absolute !important;
}
.gisogd-doc-properties {
  padding-top: 15px;
}
</style>